var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "steps-bar" },
    [
      _c(
        "a",
        {
          staticClass: "steps-bar__item completed",
          class: _vm.isActive(1) ? "active" : "",
          attrs: { href: _vm.navigation.home },
          on: {
            click: function ($event) {
              return _vm.clickEvent(1, $event)
            },
          },
        },
        [
          _c("div", { staticClass: "steps-bar__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "50",
                  viewBox: "0 0 95 78",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M89.0332 3.80078H5.94364C4.76017 3.80078 3.80078 4.76014 3.80078 5.94361V18.1077C3.80078 19.2912 4.76017 20.2506 5.94364 20.2506H89.0332C90.2166 20.2506 91.176 19.2912 91.176 18.1077V5.94361C91.176 4.76014 90.2166 3.80078 89.0332 3.80078Z",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M13.903 8.89844H10.1104C9.4648 8.89844 8.94141 9.42179 8.94141 10.0674V13.9677C8.94141 14.6134 9.4648 15.1367 10.1104 15.1367H13.903C14.5486 15.1367 15.072 14.6134 15.072 13.9677V10.0674C15.072 9.42179 14.5486 8.89844 13.903 8.89844Z",
                    stroke: "currentColor",
                    "stroke-width": "3.77953",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M26.0469 12.0615L51.9952 12.0312Z",
                    fill: "currentColor",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M26.0469 12.0615L51.9952 12.0312",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M74.0605 30.8125H5.97099C4.78752 30.8125 3.82812 31.7719 3.82812 32.9553V45.1194C3.82812 46.3029 4.78752 47.2622 5.97099 47.2622H74.0605C75.244 47.2622 76.2034 46.3029 76.2034 45.1194V32.9553C76.2034 31.7719 75.244 30.8125 74.0605 30.8125Z",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M13.9303 35.9062H10.1378C9.49214 35.9062 8.96875 36.4296 8.96875 37.0752V40.9755C8.96875 41.6212 9.49214 42.1446 10.1378 42.1446H13.9303C14.5759 42.1446 15.0993 41.6212 15.0993 40.9755V37.0752C15.0993 36.4296 14.5759 35.9062 13.9303 35.9062Z",
                    stroke: "currentColor",
                    "stroke-width": "3.77953",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M26.0742 39.0733L52.0225 39.043Z",
                    fill: "currentColor",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M26.0742 39.0733L52.0225 39.043",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M89.0527 57.7734H5.96317C4.7797 57.7734 3.82031 58.7328 3.82031 59.9163V72.0803C3.82031 73.2638 4.7797 74.2232 5.96317 74.2232H89.0527C90.2362 74.2232 91.1956 73.2638 91.1956 72.0803V59.9163C91.1956 58.7328 90.2362 57.7734 89.0527 57.7734Z",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M13.9225 62.8711H10.13C9.48433 62.8711 8.96094 63.3944 8.96094 64.0401V67.9404C8.96094 68.586 9.48433 69.1095 10.13 69.1095H13.9225C14.5681 69.1095 15.0915 68.586 15.0915 67.9404V64.0401C15.0915 63.3944 14.5681 62.8711 13.9225 62.8711Z",
                    stroke: "currentColor",
                    "stroke-width": "3.77953",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M26.0703 66.0341L52.0186 66.0039Z",
                    fill: "currentColor",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M26.0703 66.0341L52.0186 66.0039",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "steps-bar__name" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getTranslation("cart-steps-vue", "product_selection")
                ) +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.stepExists("licences_setup")
        ? [
            _c("div", { staticClass: "steps-bar__separator" }, [
              _c("img", {
                attrs: {
                  src: _vm.imgPath + "images/steps-bar/ico-dots.svg",
                  alt: "",
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "steps-bar__item configureLicenses",
                class: _vm.getClass(_vm.navigation.licences_setup, 2),
                attrs: {
                  href:
                    _vm.maxStep >= 2 && !_vm.isActive(2)
                      ? _vm.navigation.licences_setup
                      : "javascript:;",
                },
                on: {
                  click: function ($event) {
                    return _vm.clickEvent(2, $event)
                  },
                },
              },
              [
                _c("div", { staticClass: "steps-bar__icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "50",
                        viewBox: "0 0 95 78",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M68.6668 22.6507C76.3326 25.8641 76.1549 15.421 82.0075 21.3233C87.86 27.2257 77.4188 26.9595 80.5671 34.6523C83.7155 42.345 90.9742 34.8348 90.939 43.147C90.9039 51.459 83.7089 43.8877 80.4956 51.5536C77.2822 59.2193 87.7253 59.0417 81.8229 64.8942C75.9206 70.7468 76.1867 60.3056 68.494 63.454C60.8012 66.6023 68.3113 73.8611 59.9993 73.8259C51.6872 73.7919 59.2585 66.5957 51.5927 63.3823C43.9269 60.1689 44.1046 70.612 38.252 64.7097C32.3994 58.8073 42.8407 59.0735 39.6923 51.3808C36.544 43.688 29.2852 51.1982 29.3204 42.8861C29.3556 34.5741 36.5505 42.1453 39.7639 34.4795C42.9773 26.8137 32.5342 26.9913 38.4365 21.1388C44.3389 15.2862 44.0728 25.7274 51.7655 22.5791C59.4583 19.4307 51.9482 12.172 60.2602 12.2072C68.5722 12.2412 61.0009 19.4373 68.6668 22.6507Z",
                          fill: "white",
                          stroke: "#747474",
                          "stroke-width": "4",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M2.06237 72.1298L2.04688 34.2536V27.1719H7.44799H27.9889L28.0044 72.1298C20.4024 76.7776 11.0789 77.6334 2.06237 72.1298V72.1298Z",
                          fill: "white",
                          stroke: "#747474",
                          "stroke-width": "4",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M8.08984 66.2378C13.0804 69.2144 17.0257 69.2145 22.0075 66.2227",
                          stroke: "#747474",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M4.22243 27.0932L4.08984 2.21194L26.0102 2.10156L25.966 27.1818L4.22243 27.0932Z",
                          fill: "white",
                          stroke: "#747474",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M9.05002 7.05147L9.03906 12.0457H12.0553L12.0515 7.05078L9.05002 7.05147Z",
                          fill: "#747474",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M18.0422 7.05147L18.0312 12.0457H21.0475L21.0437 7.05078L18.0422 7.05147Z",
                          fill: "#747474",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M51.0977 44.3855C50.8765 42.1298 51.5997 39.8823 53.1082 38.1373C54.6167 36.3923 56.787 35.2927 59.1418 35.0805C61.4965 34.8683 63.8428 35.5608 65.6646 37.0057C67.4863 38.4506 68.6344 40.5296 68.8562 42.7853C69.078 45.041 68.3554 47.2887 66.8473 49.034C65.3392 50.7794 63.1691 51.8794 60.8145 52.0921C58.4598 52.3049 56.1133 51.6129 54.2912 50.1684C52.4691 48.724 51.3205 46.6453 51.0981 44.3897L51.0977 44.3855Z",
                          fill: "white",
                          stroke: "#747474",
                          "stroke-width": "4",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "steps-bar__name" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getTranslation(
                          "cart-steps-vue",
                          "license_configurator"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "steps-bar__separator" }, [
        _c("img", {
          attrs: {
            src: _vm.imgPath + "images/steps-bar/ico-dots.svg",
            alt: "",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "steps-bar__item",
          class: _vm.getClass(_vm.navigation.user_info, 3),
          attrs: {
            href:
              _vm.maxStep >= 3 && !_vm.isActive(3)
                ? _vm.navigation.user_info
                : "javascript:;",
          },
          on: {
            click: function ($event) {
              return _vm.clickEvent(3, $event)
            },
          },
        },
        [
          _c("div", { staticClass: "steps-bar__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "50",
                  viewBox: "0 0 50 42",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M44.5769 7.41406H5.38476C3.56718 7.41406 2.09375 8.8875 2.09375 10.7051V35.7302C2.09375 37.5478 3.56718 39.0212 5.38476 39.0212H44.5769C46.3945 39.0212 47.868 37.5478 47.868 35.7302V10.7051C47.868 8.8875 46.3945 7.41406 44.5769 7.41406Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M39.4944 24.5176C39.4944 24.5176 31.8735 14.3183 32.3453 8.12067C32.817 1.92306 36.1494 1.06981 39.4944 1.07819C42.8395 1.08614 46.0976 2.04683 46.6081 8.15624C47.1186 14.2657 39.4944 24.5176 39.4944 24.5176V24.5176Z",
                    fill: "white",
                    stroke: "currentColor",
                    "stroke-width": "2",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M36.6132 9.15782C36.3806 8.39661 36.4558 7.57318 36.8222 6.86792C37.1885 6.16266 37.8163 5.63308 38.5679 5.39518C39.3194 5.15728 40.1336 5.23044 40.8319 5.59867C41.5303 5.9669 42.0559 6.60014 42.2936 7.3597C42.5314 8.11926 42.4619 8.94319 42.1003 9.651C41.7388 10.3588 41.1147 10.8928 40.3648 11.1359C39.6149 11.3791 38.8002 11.3117 38.0994 10.9484C37.3985 10.585 36.8686 9.95545 36.6256 9.19758",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M6.32422 11.6367H25.2058",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M6.30469 16.9023H25.1863",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M6.32794 24.7891H33.0942V35.8826H6.29297L6.32794 24.7891Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M6.39062 25.0584L19.4169 30.5189L32.9367 24.8281",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M6.58594 35.6528L16.2899 29.2383",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M32.9363 35.6205L22.8047 29.3047",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "steps-bar__name" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getTranslation("cart-steps-vue", "contact_information")
                ) +
                "\n\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "steps-bar__separator" }, [
        _c("img", {
          attrs: {
            src: _vm.imgPath + "images/steps-bar/ico-dots.svg",
            alt: "",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "steps-bar__item",
          class: _vm.getClass(_vm.navigation.order_summary, 4),
          attrs: {
            href:
              _vm.maxStep >= 4 && !_vm.isActive(4)
                ? _vm.navigation.order_summary
                : "javascript:;",
          },
          on: {
            click: function ($event) {
              return _vm.clickEvent(4, $event)
            },
          },
        },
        [
          _c("div", { staticClass: "steps-bar__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "50",
                  viewBox: "0 0 50 42",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M21.1456 2.07422H5.56054C3.74296 2.07422 2.26953 3.54766 2.26953 5.36523V35.6561C2.26953 37.4737 3.74296 38.9471 5.56054 38.9471H21.1456C22.9632 38.9471 24.4366 37.4737 24.4366 35.6561V5.36523C24.4366 3.54766 22.9632 2.07422 21.1456 2.07422Z",
                    fill: "white",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M10.2148 5.78906H21.2181",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M5.44169 5.78906H5.42578",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M10.2188 10.0195H21.222",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M5.44951 10.0195H5.43359",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M9.12891 28.2181L12.6717 32.6589L17.5089 24.7148",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M5.28422 30.3889C4.62878 28.2766 4.84059 25.9916 5.87326 24.0345C6.90592 22.0774 8.67525 20.6078 10.7936 19.9476C12.912 19.2874 15.2067 19.4905 17.1751 20.5123C19.1434 21.5341 20.625 23.2914 21.2951 25.3992C21.9652 27.507 21.7693 29.7934 20.7503 31.7575C19.7312 33.7217 17.9722 35.2035 15.8584 35.8783C13.7447 36.5531 11.4486 36.3659 9.4732 35.3577C7.49778 34.3494 6.00408 32.6024 5.31931 30.4993",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M10.1797 14.2266H21.183",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M5.41045 14.2266H5.39453",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M25.5317 35.308L48.9625 35.3313L48.9392 25.1201C47.3029 22.7908 45.4558 20.9407 42.8618 20.7881C41.697 15.8305 40.3582 11.1012 37.8088 7.96104L30.2498 7.95703L30.2319 24.3076L30.2334 27.428L30.2155 24.2791L25.5312 24.2612L25.5317 35.308Z",
                    fill: "white",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M36.4191 36.5941C36.1502 35.7264 36.2371 34.7878 36.6607 33.9839C37.0843 33.1799 37.81 32.5762 38.6789 32.305C39.5478 32.0338 40.4891 32.1172 41.2965 32.537C42.1039 32.9567 42.7116 33.6786 42.9864 34.5444C43.2613 35.4103 43.1809 36.3495 42.763 37.1563C42.345 37.9632 41.6234 38.5719 40.7564 38.8491C39.8894 39.1262 38.9476 39.0493 38.1373 38.6352C37.327 38.221 36.7143 37.5034 36.4335 36.6395",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M36.4191 36.5941C36.1502 35.7264 36.2371 34.7878 36.6607 33.9839C37.0843 33.1799 37.81 32.5762 38.6789 32.305C39.5478 32.0338 40.4891 32.1172 41.2965 32.537C42.1039 32.9567 42.7116 33.6786 42.9864 34.5444C43.2613 35.4103 43.1809 36.3495 42.763 37.1563C42.345 37.9632 41.6234 38.5719 40.7564 38.8491C39.8894 39.1262 38.9476 39.0493 38.1373 38.6352C37.327 38.221 36.7143 37.5034 36.4335 36.6395",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M34.207 20.5887L39.1004 20.6047L35.8501 12.1719",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "steps-bar__name" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getTranslation(
                    "cart-steps-vue",
                    "summary_and_confirmation"
                  )
                ) +
                "\n        "
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }